import { IFilter, IRootState, IFilterGrouping } from '@/store/types/IRootState';

const categoryFilterGetters = {
    getNCategoryGroupings: ({ categoryFilters }: IRootState) => (numberFiltersToShow: number): IFilterGrouping[] => {
        return categoryFilters.showAllFilters ?
            categoryFilters.groupings : categoryFilters.groupings.slice(0, numberFiltersToShow);
    },
    getNumberOfRemainingCategoryGroupings: ({ categoryFilters }: IRootState) => (numberFiltersToShow: number): number => {
        return categoryFilters.groupings.length - numberFiltersToShow;
    },
    getCheckedCategoryFilters: (state: IRootState): IFilter[] => {
        const filters = state.categoryFilters.groupings.flatMap(g => g.filters);
        return filters.filter(f => f.checked)
            .concat(filters.flatMap(f => f.subfilters || []).filter(f => f.checked));
    },
    getShowAllCategoryFilters: (state: IRootState): boolean => {
        return state.categoryFilters.showAllFilters;
    },
    getCategoryFiltersLength: (state: IRootState): number => {
        return state.categoryFilters.groupings.length;
    },
    hasCategoryFilters(state: IRootState): boolean {
        return state.categoryFilters.groupings.length > 0;
    },
    getShowFilterGroupCategoryFilters: (state: IRootState): boolean => {
        return state.categoryFilters.showFilterGroup;
    },
    displayCategoryFilter: (state: IRootState) => (grouping: IFilterGrouping): boolean => {
        return !(grouping.filters.length === 1 && grouping.filters[0].count === state.itemsCounter);
    },
};

export default categoryFilterGetters;
